import {madnes_fill_range, madnes_reverse} from "../framework/src/engine/madnes/madnes";

var lines = new Array();

var render_move_per_sec = 16; // Symbolu za sekundu
var render_move_per_sec_free = 26; // Symbolu za sekundu ve free spinu

export const cylinder_pos = new Array();
cylinder_pos[0] = 58;
cylinder_pos[1] = 295;
cylinder_pos[2] = 532;
cylinder_pos[3] = 767;
cylinder_pos[4] = 1002;

export const icons = {
    "symbol_Whisky": {
        stop: [0],
        anim: madnes_fill_range(1,5),
        anim_reverse: madnes_reverse(madnes_fill_range(1,5))
    },
    "symbol_Colts": {
        stop: [0],
        anim: madnes_fill_range(1,5),
        anim_reverse: madnes_reverse(madnes_fill_range(1,5))
    },
    "symbol_Dollars": {
        stop: [0],
        anim: madnes_fill_range(1,5),
        anim_reverse: madnes_reverse(madnes_fill_range(1,5))
    },
    "symbol_Cards": {
        stop: [0],
        anim: madnes_fill_range(1,5),
        anim_reverse: madnes_reverse(madnes_fill_range(1,5))
    },
    "symbol_Bandit-1": {
        stop: [0],
        anim: madnes_fill_range(1,5),
        anim_reverse: madnes_reverse(madnes_fill_range(1,5))
    },
    "symbol_Bandit-2": {
        stop: [0],
        anim: madnes_fill_range(1,5),
        anim_reverse: madnes_reverse(madnes_fill_range(1,5))
    },
    "symbol_Bandit-3": {
        stop: [0],
        anim: madnes_fill_range(1,5),
        anim_reverse: madnes_reverse(madnes_fill_range(1,5))
    },
    "symbol_Bonus": {
        stop:  [0],
        blur:  [60],
        win:   madnes_fill_range(30, 59),
        nowin: madnes_fill_range( 0, 29)
    },
    "symbol_Scatter": {
        stop: [0],
        anim: madnes_fill_range(0, 29)
    },
    "symbol_Wild-1": {
        stop: [0],
        anim: madnes_fill_range(0, 29),
        flip: madnes_fill_range(30, 39),
        flip_back: madnes_reverse(madnes_fill_range(30, 39))
    },
    "symbol_Wild-2": {
        stop: [0],
        anim: madnes_fill_range(0, 29),
        flip: madnes_fill_range(30, 39),
        flip_back: madnes_reverse(madnes_fill_range(30, 39))
    }
}

export let icons_tmp = new Array();

export const symbols = new Array();
symbols[0] = -1;
symbols[1] = -1;
symbols[2] = -1;
symbols[3] = -1;
symbols[4] = -1;

export const last_symbol = new Array();
last_symbol[0] = -1;
last_symbol[1] = -1;
last_symbol[2] = -1;
last_symbol[3] = -1;
last_symbol[4] = -1;

var reels_lenghts = new Array();
var reels_pos = new Array();

var img_laoder;

var diry = new Array();

export var smoke_manager;

function init_game(dname, cfg)
{
    // madnes_show_money_pos_y = he / 2 - 20;
    //
    // madnes_load_init("wanted", cfg);
    //
    // madnes_set_page_bg(dname, imgsPath + "web/background.png");
    //
    // madnes_set_texture_version(58);
    //
    // //madnes_set_on_rotate_click('madnes_audio_play("button_click");');
    // //madnes_set_on_rotate_click('button_click');
    //
    // madnes_set_ico_size(222, 202);
    // madnes_set_win_factors(25, 50, 125); // !!!!!!!!!!!!!!!
    // madnes_set_native_sceen_size(1280, 720);
    //
    // for(var i in to_load_audio)
    // {
    //     madnes_add_audio(i, to_load_audio[i]);
    // }
    //
    // for(var i in to_load_json)
    // {
    //     if(infotexts_languages.indexOf(lang) === -1)
    //     {
    //         to_load_json[i] = to_load_json[i].replace("{l}", def_lang);
    //     }
    //
    //     madnes_add_json(i, to_load_json[i]);
    // }
    //
    // for(var i in to_load)
    // {
    //     madnes_add_to_load(i, to_load[i]);
    // }
    //
    // for(var i in to_load_fonts)
    // {
    //     madnes_add_font_to_load(i, to_load_fonts[i]);
    // }
    //
    // madnes_set_sprite('_sprite', ico_wi, ico_he);
    //
    // madnes_set_sprite('_blur', ico_wi, ico_he);
    //
    // madnes_set_sprite('wheel_sprite', 580, 580);
    // madnes_set_sprite('shot_sprite', 154, 126);
    // madnes_set_sprite('colt_sprite', 188, 534);
    // madnes_set_sprite('bonus_Winfont_Big', 64, 108);
    // madnes_set_sprite('bonus_Winfont_Small', 64, 108);
    // madnes_set_sprite('big-win_Start_sprite', 1280 / 2, 800 / 2);
    // madnes_set_sprite('spark_sprite_', 306, 306);
    // madnes_set_sprite('intro_sprite_', 1280 / 2, 800 / 2);
    //
    // madnes_set_default_volume(0.8);
    //
    // madnes_set_audio_volume("BACKGROUND", 0.6);
    //
    //
    // madnes_set_printdesk_function(wanted_print_desk);
    // madnes_set_updatedesk_function(wanted_print_reels);
    // madnes_set_rotate_function(wanted_rotate_run);
    //
    // //madnes_set_on_rotate_release("rotate_release()");
    //
    // madnes_set_infomenu_init_function(wanted_infomenu_init);
    // madnes_set_infomenu_open_function(wanted_infomenu_open);
    // madnes_set_infomenu_close_function(wanted_infomenu_close);
    // madnes_set_infomenu_update_function(wanted_infomenu_update);
    // madnes_set_infomenu_left_function(wanted_infomenu_left);
    // madnes_set_infomenu_right_function(wanted_infomenu_right);
    //
    // madnes_set_coin_values_init(function(currency)
    // {
    //     if(currency === "PLN")
    //     {
    //         coin_values = [0.1, 1];
    //     }
    //     else
    //     {
    //         madnes_coin_values_init(currency);
    //     }
    // });
    //
    // madnes_set_on_rotate_release(rotate_release);
    // madnes_set_on_forcestop_press(forcestop_press);
    //
    // madnes_init(dname);
}
/*
window.onerror = function(msg, url, linenumber)
{
    alert('Error message: '+msg+'\nURL: '+url+'\nLine Number: '+linenumber);
    return true;
}
*/
